module.exports = __webpack_public_path__ + "static/media/login-ubeya.ed0c9046.jpg";